$(document)
    .ready(function () {
        // ověření subjektu v ARES
        $('#button-ares-check')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();

                $('#button-ares-check').prop('disabled', true).attr('disabled', true);

                var url = window.location.protocol + '//' + window.location.host;
                var idSection = $('#idSection').val();
                var idItem = $('#idItem').val();

                url += '/plugin/PluginAres/ajaxCheckSubjectInAres';

                if (idSection.length) {
                    url += '/' + idSection;
                    if (idItem.length) {
                        url += '/' + idItem;
                    }
                }

                var _ch = $('#_ch');
                if(!_ch.length) {
                    return;
                }

                $.ajax({
                    type: 'post',
                    url: url,
                    dataType: "json",
                    global: true,
                    data: {'_ch': _ch.val()},
                    beforeSend: function () {
                        Lemo_Alert.addInfo('Ověřuji subjekt v ARES ...', 'aresCheckBeforeSend');
                    },
                    complete: function () {
                        Lemo_Alert.closeById('aresCheckBeforeSend');
                        $('#button-ares-check').prop('disabled', false).attr('disabled', false);
                    },
                    success: function (r) {

                        if (r.hasOwnProperty('messages')) {
                            Lemo_Alert.addMany(r.messages);
                        }

                        if (r.hasOwnProperty('status') && true == r.status) {
                            if (r.hasOwnProperty('data')) {

                                var data = r.data;
                                if (data.hasOwnProperty('idtyp')) {
                                    $("#subjekttyp").val(data['idtyp']);
                                }

                                if (data.hasOwnProperty('nazev')) {
                                    $('#subjektnazev').val(data['nazev']);
                                }

                                if (data.hasOwnProperty('dic')) {
                                    $('#subjektdic').val(data['dic']);
                                }

                                if (data.hasOwnProperty('platcedph')) {
                                    if (true == data['platcedph']) {
                                        $('#subjektplatcedph').prop('checked', true).attr('checked', true);
                                    } else {
                                        $('#subjektplatcedph').prop('checked', false).attr('checked', false);
                                    }
                                }

                                // odstranění údajů fyzické osoby nepodnikatele
                                $('#subjektkrestnijmeno').val('');
                                $('#subjektprijmeni').val('');
                                $('#subjektrc').val('');

                                $('#aresovereno').prop('checked', true).attr('checked', true);
                            }
                        } else {
                            // odstranění příznaku ares
                            $('#aresovereno').prop('checked', false).attr('checked', false);
                        }
                    },
                    error: function (html) {
                        Lemo_Alert.addDanger('Ověření subjektu v ARES selhalo', 'aresCheckError');
                    }
                });

                return true;
            }
        );

    });
